import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TPostGenerateCompanyShareableLinkRequest } from "./postGenerateCompanyShareableLink.schema";

export const postGenerateCompanyShareableLink = (axios: IAxiosInstance) => {
  return async (body: TPostGenerateCompanyShareableLinkRequest) => {
    const response = await axios.noRetry.post<ZealApiResponse<string>>(
      "/api/postGenerateCompanyShareableLink",
      body
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
